/**
 * NEXORA AI - LanguageStep (Refactorisé avec Design System)
 * Epic 1.3 Phase 2.2 - Onboarding Premium
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import SelectionCard, { SelectionCardGrid } from '../ui/selection-card';
import StepHeader from '../ui/step-header';
import ValidationMessage from '../ui/validation-message';

const LANGUAGES = [
  { id: 'fr', label: 'Français', icon: '🇫🇷' },
  { id: 'en', label: 'English', icon: '🇬🇧' },
  { id: 'es', label: 'Español', icon: '🇪🇸' },
  { id: 'de', label: 'Deutsch', icon: '🇩🇪' },
  { id: 'it', label: 'Italiano', icon: '🇮🇹' },
  { id: 'pt', label: 'Português', icon: '🇵🇹' }
];

export default function LanguageStep({ data, onNext, onBack, onData }) {
  const { t, i18n } = useTranslation('onboarding');
  const [selected, setSelected] = useState(data.language || i18n.language);
  const [showValidation, setShowValidation] = useState(false);

  const handleSelect = (langId) => {
    setSelected(langId);
    onData({ language: langId });
    i18n.changeLanguage(langId);
  };

  const handleNext = () => {
    if (selected) {
      setShowValidation(true);
      setTimeout(() => onNext(), 1200);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-4xl"
      >
        <StepHeader
          icon={<Languages className="text-purple-400" />}
          title={t('language_title')}
          subtitle={t('language_subtitle')}
        />

        <SelectionCardGrid cols={3} className="mb-8">
          {LANGUAGES.map((lang) => (
            <SelectionCard
              key={lang.id}
              id={lang.id}
              selected={selected === lang.id}
              onSelect={handleSelect}
              icon={lang.icon}
              title={lang.label}
              size="md"
              testId={`language-${lang.id}`}
            />
          ))}
        </SelectionCardGrid>

        <ValidationMessage
          show={showValidation}
          type="success"
          message={t('validation_language')}
        />

        <div className="flex justify-between items-center">
          <Button variant="ghost" onClick={onBack} className="min-h-[44px]">
            {t('back')}
          </Button>
          <Button
            onClick={handleNext}
            disabled={!selected || showValidation}
            className="min-h-[44px] bg-purple-600 hover:bg-purple-500"
          >
            {t('continue')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
